import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    policyChangeEffectiveDate: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    description: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Description:',
        defaultMessage: 'Description:'
    },
    secondaryNamedInsured: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Secondary Named Insured',
        defaultMessage: 'Secondary Named Insured'
    },
    add: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Add',
        defaultMessage: 'Add'
    },
    address: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.Address',
        defaultMessage: 'Address'
    },
    policyType: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.PolicyType.label',
        defaultMessage: 'What policy type is this associated with?'
    },
    baseState: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.BaseState',
        defaultMessage: 'Base State'
    },
    riskType: {
        id: 'premier.policychange.spaAndWellLine.views.policyChangesPage.riskType',
        defaultMessage: 'Risk Type'
    },
});
